import { Component } from '@angular/core';
import { ReferralsComponent } from './referrals.component';

@Component({
  selector: 'eid-referrals-mobile',
  templateUrl: './referrals.mobile.component.html',
  styleUrls: ['./referrals.mobile.component.scss']
})
export class ReferralsMobileComponent extends ReferralsComponent {}
